export default {"src":"/_next/static/media/deco_checkout_checkmark_filled.d90d586c.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};